<template>
  <div>
    <v-card
      class="mx-auto"
      max-width="800"
      elevation="10"
    >
      <v-img
        class="card-container white--text"
        height="35vh"
        :src="mainImg"
      >
        <div
          v-if="cardData.ForRent"
          class="forRent"
        >Kiadásra is</div>
        <v-card-title class="align-end justify-end fill-height">{{cardData.Location}}</v-card-title>
      </v-img>

      <v-card-actions>
        <v-btn
          text
          color="#d3b364"
          @click.stop="showInfoDialog = true;"
        >
          Információ
        </v-btn>
        <v-btn
          text
          color="#d3b364"
          @click="imgIndex = 1"
        >
          Képek
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
      scrollable
      v-model="showInfoDialog"
      max-width="650"
    >
      <v-card>
        <v-card-text class="modal-card-text">
          <div
            v-if="cardData.Price"
            style="color: ghostwhite"
          > Ár: {{cardData.Price}}</div>
          <div>Helyszín: {{cardData.Location}}</div>
          <div v-if="this.techDocLink"><a :href="this.techDocLink">Műszaki leírás</a></div>
          <div v-if="cardData.YearBuilt"> Építés éve: {{cardData.YearBuilt}}</div>
          <div v-if="cardData.Handover"> Átadás: {{cardData.Handover}}</div>
          <div class="modal-card-infotext">
            {{cardData.Info}}
          </div>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1">
            <v-btn
              color="#d3b364"
              text
              @click="showInfoDialog = false; showAskForPriceDialog = true;"
            >
              Egyedi árat kérek
            </v-btn>
          </div>

          <v-btn
            color="#d3b364"
            text
            @click="showInfoDialog = false"
          >
            Bezárás
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="showAskForPriceDialog"
      max-width="650"
    >
      <v-card>
        <v-card-text class="modal-card-text">
          <v-form
            ref="form"
            v-model="valid"
            class="form"
          >
            <v-text-field
              v-model="name"
              :rules="nameRules"
              :label="'Név'"
              required
            ></v-text-field>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              :label="'Email'"
              required
            ></v-text-field>
            <v-textarea
              v-model="message"
              name="input-7-1"
              :label="'Üzenet'"
            ></v-textarea>
          </v-form>
          <v-snackbar
            v-model="successSnackbar"
            color="snackbar-success"
          >
            Üzenet sikeresen elküldve!
          </v-snackbar>
          <v-snackbar
            v-model="errorSnackbar"
            color="error"
          >
            Üzenet küldés sikertelen.
          </v-snackbar>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1">
            <v-btn
              color="#d3b364"
              text
              :disabled="!valid"
              v-on:click.native="sendMail"
            >
              Küldés
            </v-btn>
          </div>

          <v-btn
            color="#d3b364"
            text
            @click="showAskForPriceDialog = false"
          >
            Bezárás
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <vue-gallery-slideshow
      :images="imgUrls"
      :index="imgIndex"
      @close="imgIndex = null"
    ></vue-gallery-slideshow>
  </div>
</template>

<script>
import VueGallerySlideshow from "vue-gallery-slideshow";
import firebase from "firebase/app";
import "@firebase/storage";
import "@firebase/auth";

export default {
  components: {
    VueGallerySlideshow
  },
  props: ["cardData"],
  data() {
    return {
      showInfoDialog: false,
      showAskForPriceDialog: false,
      imgIndex: null,
      imgUrls: [],
      mainImg: "",
      techDocLink: "",
      valid: false,
      name: "",
      email: "",
      message: "",
      successSnackbar: false,
      errorSnackbar: false,
      loadingAnimation: false,
      nameRules: [v => !!v || "Kérem adja meg a nevét!"],
      emailRules: [
        v => !!v || "Kérem adja meg az e-mail címét!",
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Érvényes e-mail címnek kell lennie!"
      ]
    };
  },
   methods: {
    sendMail: function() {
      let self = this;
      self.$data.loadingAnimation = true;

      this.$http
        .post("https://us-central1-dragonainvest.cloudfunctions.net/sendMail", {
          name: this.$data.name,
          email: this.$data.email,
          message: this.$data.message,
          item: this.cardData.ImgFolder
        })
        .then(res => {
          // console.log(res);
          self.$refs.form.reset();
          self.$data.successSnackbar = true;
          self.$data.loadingAnimation = false;
          self.showAskForPriceDialog = false;
        })
        .catch(err => {
          self.$data.loadingAnimation = false;
          self.$data.errorSnackbar = true;
          console.log(err);
        });
    },
    closeAskPriceDialog: function() {
      let self = this;
      self.showAskForPriceDialog = false;
      self.name = '',
      self.email = '',
      self.message = ''
    }
  },
  created: function() {
    // console.log("Created", firebase.storage().ref(this.cardData.ImgFolder + '/TechDoc'));

    // Load images

    firebase
      .storage()
      .ref(this.cardData.ImgFolder)
      .listAll()
      .then(res => {
        res.items.forEach(imageRef => {
          imageRef.getDownloadURL().then(url => {
            if (url.includes("image001")) {
              this.mainImg = url;
            }

            this.imgUrls.push(url);
            //console.log(url);
          });
        });
      });

    if (!this.mainImg) {
      this.mainImg = this.imgUrls[0];
    }

    // Load technical documentation

    firebase
      .storage()
      .ref(this.cardData.ImgFolder + "/TechDoc")
      .listAll()
      .then(res => {
        res.items.forEach(techDocRef => {
          techDocRef.getDownloadURL().then(url => {
            this.techDocLink = url;
            // console.log('TechDoc url: ', url);
          });
        });
      });
  }
};
</script>

<style scoped>
.card-container {
  position: relative;
}

.forRent {
  position: absolute;
  top: 31px;
  left: -33px;
  background-color: #710000;
  font-size: 1.3rem;
  padding: 0px 1.7rem 0 1.7rem;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.v-card__title {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    180deg,
    rgba(2, 0, 36, 0) 0%,
    rgba(0, 0, 9, 0.24693627450980393) 65%,
    rgba(0, 0, 0, 0.8519782913165266) 100%
  );
  font-weight: 100;
  font-size: 2rem;
}

.modal-card-text {
  text-align: center;
  font-size: 1.3rem;
  line-height: 2rem;
}

.modal-card-infotext {
  text-align: justify;
  font-size: 1rem;
  margin-top: 1rem;
  line-height: 2rem;
}

@media screen and (max-width: 600px) {
  .v-application .mx-auto {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
}
</style>